import { render } from "./CareerGoalsSection.vue?vue&type=template&id=33d62da5&scoped=true"
import script from "./CareerGoalsSection.vue?vue&type=script&lang=js"
export * from "./CareerGoalsSection.vue?vue&type=script&lang=js"

import "./CareerGoalsSection.vue?vue&type=style&index=0&id=33d62da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d62da5"]])

export default __exports__